import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'cube-unfolded', 'CubeUnfolded', [["path",{"d":"M2 15h10v5h5v-5h5v-5h-10v-5h-5v5h-5l0 5"}],["path",{"d":"M7 15v-5h5v5h5v-5"}]]);